import { useToast } from '@kanda-libs/ks-design-library';
import { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectors } from 'store';
import { useSubscriptionContext } from '../../context';
import { STANDARD_YEARLY_CARD } from './constants';
import { getBaseUrl } from './helpers';
import StripeBadge from './StripeBadge';
import type { SubscriptionCardProps } from './SubscriptionCard';

export interface SubscriptionsBypassHook {
  subscriptions: SubscriptionCardProps[];
  isLoading: boolean;
  isSubmitting: boolean;
}

export default function useSubscriptionsBypass(): SubscriptionsBypassHook {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const companies = useSelector(selectors.company.getEntitiesAsArray);
  const { isLoading } = useSubscriptionContext();

  const { showError } = useToast();

  const company = useMemo(() => {
    if (!companies || companies?.length === 0) return null;
    return companies[0];
  }, [companies]);

  const onYearlyClick = useCallback(() => {
    setIsSubmitting(true);
    const id = company?.id;
    if (!id) {
      showError('Error creating subscription - company id missing');
      setIsSubmitting(false);
      return;
    }
    const url = `${getBaseUrl()}/billing/success?cid=${id}&tier=base_rate&provider=stripe`;
    window.location.href = url;
  }, [company, showError]);

  const subscriptions: SubscriptionCardProps[] = useMemo(
    () => [
      {
        ...STANDARD_YEARLY_CARD,
        buttonProps: {
          ...STANDARD_YEARLY_CARD.buttonProps,
          onClick: onYearlyClick,
          disabled: isSubmitting,
        },
        badge: <StripeBadge />,
      },
    ],
    [isSubmitting, onYearlyClick],
  );

  return {
    subscriptions,
    isLoading,
    isSubmitting,
  };
}
